import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss']
})
export class DefaultFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  navigateToFirstPage() {
    window.open('https://yuteam.co.rs/', '_blank');
  }

  navigateToContact() {
    window.open('https://minibiz.rs/minibiz-kontakti/', '_blank');
  }
  navigateToUsloviKoriscenja() {
    window.open('https://minibiz.rs/uslovi_koriscenja_aplikacije_minibiz/', '_blank')
  }
}
